import { Box, Container, Typography, Paper, CircularProgress } from '@mui/material'

export function MaintenancePage({ message, estimatedEndTime }) {
  const formatTime = (dateString) => {
    if (!dateString) return null
    // Check if time is midnight UTC (sentinel for date-only)
    const isDateOnly = dateString.endsWith('T00:00:00.000Z')
    if (isDateOnly) {
      // Parse date parts directly to avoid timezone shift
      const [year, month, day] = dateString.split('T')[0].split('-')
      const date = new Date(year, month - 1, day)
      return date.toLocaleDateString(undefined, { dateStyle: 'long' })
    }
    const date = new Date(dateString)
    return date.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 2,
          }}
        >
          <Box component="img" src="/givewise-logo-wordmark.png" alt="GiveWise Logo" sx={{ height: 60, mb: 4 }} />

          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
            We&apos;ll be right back
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, whiteSpace: 'pre-line' }}>
            {message ||
              "We're updating the system to keep everything running smoothly, so you can get back to your generosity as soon as possible.\n\nThanks for your patience. Please check back shortly."}
          </Typography>

          {estimatedEndTime && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Estimated completion: {formatTime(estimatedEndTime)}
            </Typography>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress size={24} />
            <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
              Working on it...
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}

export default MaintenancePage
